import { render, staticRenderFns } from "./Element.vue?vue&type=template&id=6dc52f88&"
import script from "./Element.vue?vue&type=script&lang=js&"
export * from "./Element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports